import { confidenceAdminPlugin } from '@spotify/plugin-confidence-admin';
import { confidenceChatPlugin } from '@spotify/plugin-confidence-chat';
import { projectsPlugin } from '@spotify/plugin-confidence-projects';

export const documentRouteMountPaths = {
  chats: '/chats',
  projects: '/projects',
  admin: '/admin',
};

export const getDocumentPathPatterns = (
  mountPaths: typeof documentRouteMountPaths,
): string[] => [
  `${mountPaths.chats}${confidenceChatPlugin.routes.chatDocument.path}`,
  `${mountPaths.projects}${projectsPlugin.routes.projectDocument.path}`,
  `${mountPaths.admin}${confidenceAdminPlugin.routes.promptHookDocument.path}`,
];
